import React, { useEffect, useState } from 'react';
import logo from './logotechdoggroupmetpayoff.png';
import calendar from './calendar-pen.png';
import './Navbar.css';
import { Button, Popover, PopoverBody } from 'reactstrap';
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MonthPicker } from '@mui/x-date-pickers/MonthPicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import Cookies from 'universal-cookie';

const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

const Navbar = () => {
  const { month, year } = useParams();
  const cookies = new Cookies();
  const now = dayjs(`${year}-${month}`).locale('nl');
  const navigate = useNavigate();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const togglePopover = () => setPopoverOpen(!popoverOpen);
  const goTo = (date) => navigate(`/dashboard/${date.month() + 1}/${date.year()}`);

  // Pijltjes links/rechts: maand terug/vooruit; omhoog: huidige maand.
  useEffect(() => {
    if (!now.isValid()) return undefined;

    const onKey = (event) => {
      const tag = event.target?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || event.target?.isContentEditable) return;
      if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
      // In de maandkiezer zelf verplaatsen de pijltjes de focus al.
      if (event.target?.closest?.('.MonthPicker')) return;

      let target = null;
      if (event.key === 'ArrowLeft') target = now.subtract(1, 'month');
      else if (event.key === 'ArrowRight') target = now.add(1, 'month');
      else if (event.key === 'ArrowUp') target = dayjs();
      if (!target) return;

      event.preventDefault();
      goTo(target);
    };

    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [month, year]); // eslint-disable-line react-hooks/exhaustive-deps

  const logOut = () => {
    cookies.remove('token', { path: '/' });
    navigate('/');
  };

  return (
    <div>
      <nav className="d-flex justify-content-between navbar navbar-light bg-white">
        <div className="col-1 col-sm-3 h-100">
          <button className="myButton w-100 h-100" onClick={logOut}>
            Uitloggen
          </button>
        </div>
        <div className="d-flex justify-content-center col-5 col-sm-6 h-100  ">
          <img src={logo} id="logoNav" className="img-fluid m-auto" alt="Logo" />
        </div>

        <div className="d-flex justify-content-end col col-sm-3 h-100 align-middle">
          <Button
            type="button"
            className="h-50 w-0 m-auto ms-0 me-3 me-xxl-4"
            color="secondary"
            id="popoverButton"
            data-bs-toggle="popover"
            data-bs-content="Popup content"
            onClick={togglePopover}
          >
            <img src={calendar} alt='calendar-icon' className='w-auto h-75' />
          </Button>
          <Popover
            className="bodyPopover"
            placement="bottom"
            isOpen={popoverOpen}
            target="popoverButton"
            toggle={togglePopover}
          >
            <PopoverBody className="bodyPopover ps-2">
              <div className="d-flex flex-nowrap justify-content-center">
                <button
                  type="button"
                  onClick={() => goTo(now.subtract(1, 'year'))}
                  className="btn p-0 me-2"
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <h5 className="date m-0">
                  {capitalize(now.format('MMMM'))} {now.year()}
                </h5>
                <button
                  type="button"
                  onClick={() => goTo(now.add(1, 'year'))}
                  className="btn p-0 ms-2"
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </div>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MonthPicker className="MonthPicker" date={now} onChange={goTo} />
              </LocalizationProvider>
            </PopoverBody>
          </Popover>
          <div className="month m-auto ms-0 me-4" onClick={togglePopover}></div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;